import { closeModel } from "./modal-toggle";
import { lenis } from "../lenis";

export function searchModel() {
     const openBtns = document.querySelectorAll(".ms-open");
    const closeBtn = document.querySelector(".ms-close");

    if (openBtns.length) {
        openBtns.forEach(function (btn) {
            btn.addEventListener("click", function () {
                closeModel();
                document.body.classList.add("model-active-search");
                lenis.stop();
            });
        });
    }

    if (closeBtn) {
        closeBtn.addEventListener("click", function () {
            closeModel();
            lenis.start();
        });
    }
}
